import { render, staticRenderFns } from "./publisher-dialog-app.vue?vue&type=template&id=3a4bb31b"
import script from "./publisher-dialog-app.vue?vue&type=script&lang=js"
export * from "./publisher-dialog-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports